import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

// In-app player. YouTube blocks embedding for the label's auto-generated videos,
// so playback uses the official Spotify embed (30s preview / full with login),
// with a direct YouTube link alongside.
const VideoModal = ({ track, onClose }) => {
  const spotifyId = track?.spotify?.split('/track/')[1]?.split('?')[0];
  const title = track
    ? track.title.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    : '';

  return (
    <Dialog open={!!track} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-white/10 bg-ink p-0 text-neutral-200 sm:max-w-md">
        <DialogTitle className="sr-only">
          {track ? `${title} — ${track.artist || 'KHM'}` : 'Player'}
        </DialogTitle>
        <DialogDescription className="sr-only">In-app music player</DialogDescription>
        {track && (
          <div>
            {spotifyId ? (
              <iframe
                key={track.id}
                src={`https://open.spotify.com/embed/track/${spotifyId}?utm_source=generator&theme=0`}
                title={`${title} — Spotify player`}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                className="h-[352px] w-full"
              />
            ) : (
              <div className="relative aspect-video w-full overflow-hidden bg-black">
                <img
                  src={`https://i.ytimg.com/vi/${track.youtubeId}/hqdefault.jpg`}
                  alt={title}
                  className="h-full w-full object-cover"
                />
              </div>
            )}
            <div className="flex items-center justify-between gap-4 px-6 py-5">
              <div>
                <p className="text-[9px] tracking-[0.35em] text-gold">NOW PLAYING</p>
                <p className="mt-1 font-serif text-xl tracking-[0.06em] text-white">
                  {title}
                  <span className="ml-3 text-base italic text-neutral-400">
                    {track.artist || 'KHM'}
                  </span>
                </p>
              </div>
              <div className="text-right">
                <p className="text-[10px] tracking-[0.25em] text-neutral-500">
                  {track.year || '2026'} · {track.duration}
                </p>
                {track.youtube && (
                  <a
                    href={track.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 inline-flex items-center gap-1.5 text-[9px] tracking-[0.25em] text-gold transition-colors duration-300 hover:text-gold-light"
                  >
                    YOUTUBE <ExternalLink size={10} />
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
